import React from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {useStore} from "modules/hooks";
import {GAME_ZONE_URL} from "modules/constants";
import {SecondaryButton} from "components/Buttons";
import bg from "assets/images/supportedTeamCtaBg.png";

export const Wrapper = styled.div`
	margin-top: 30px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	background: url(${bg}) no-repeat center #a408a4;
	background-size: cover;
	padding: 16px;
	gap: 16px;

	@media (min-width: 769px) {
		flex-direction: row;
		padding: 24px 28px;
		gap: 20px;
	}
`;

export const Title = styled.div`
	color: #fff;
	font-feature-settings: "clig" off, "liga" off;
	font-family: "Khand", sans-serif;
	font-size: 24px;
	font-weight: 700;
	line-height: 34px;

	@media (min-width: 769px) {
		font-size: 30px;
	}
`;

export const Button = styled(SecondaryButton)`
	display: flex;
	align-items: center;
	justify-content: center;

	@media (min-width: 769px) {
		max-width: 200px;
	}
`;

export const SupportedTeamCta: React.FC = observer(() => {
	const {I18n, UIQuestionsProgress} = useStore();

	if (!UIQuestionsProgress.isShowSupportedTeamCta) {
		return null;
	}

	return (
		<Wrapper>
			<Title>{I18n.t("screens.final.supported_team")}</Title>

			<Button as="a" href={`${GAME_ZONE_URL}profile`}>
				{I18n.t("screens.final.change_now")}
			</Button>
		</Wrapper>
	);
});
